<div class="row d-flex justify-content-center align-items-center">
  <div class="col-lg-8">
    <div class="card">
      <div class="card-header d-flex justify-content-center align-items-center">
        <div
          class="cursor-pointer py-1 px-5"
          [ngClass]="currentComponent == 'info' ? 'border-bottom border-primary' : 'border-0'"
          (click)="show('info')">
          {{'RESIDENTS.GENERAL_INFO' | translate}}
        </div>
        <div
          class="cursor-pointer py-1 px-5"
          [ngClass]="currentComponent == 'password' ? 'border-bottom border-primary' : 'border-0'"
          (click)="show('password')">
          {{'USERS.PASSWORD' | translate}}
        </div>
      </div>

      <div class="card-body" [ngClass]="{
        'd-flex justify-content-relative': currentComponent == 'password'
      }">
        <ng-container *ngIf="currentComponent === 'info'">
          <user-form [profile] = true />
        </ng-container>
        <ng-container *ngIf="currentComponent === 'password'">
          <div class="col-lg-12">
            <password-change />
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
